import React from 'react';
import useSWR from 'swr';
import { GridUI } from '@next-order/next-order-components';
import './promotions-list.css'; // Specific CSS for promotions list
import { getPromotionsUrl, fetchPromotionsSWR } from './actions';
import PromotionItem from './PromotionItem';
// Main PromotionsList Component
const PromotionsList = ({
  settingId,
  level,
  themeColors,
  pointsTerminology = 'points',
}) => {
  const promotionsKey = getPromotionsUrl(settingId, level);

  const {
    data: promotions,
    error,
    isLoading,
  } = useSWR(promotionsKey, fetchPromotionsSWR, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    dedupingInterval: 10000, // dedupe requests within 10 seconds
  });

  if (isLoading) {
    return (
      <div className='promotions-list-loading'>
        {[1].map((item) => (
          <div key={item} className='promotion-placeholder'></div>
        ))}
      </div>
    );
  }

  if (error) {
    return <div className='promotions-error'>Failed to load promotions</div>;
  }

  if (!promotions || promotions.length === 0) {
    return (
      <div className='no-promotions'>No promotions available at the moment</div>
    );
  }

  return (
    <div className='promotions-list-container'>
      <GridUI align='start' gap='xs' colsTemplate={`cols-2`}>
        {promotions.map((promotion, index) => (
          <PromotionItem
            key={promotion.id || index}
            promotion={promotion}
            themeColors={themeColors}
            pointsTerminology={pointsTerminology}
          />
        ))}
      </GridUI>
    </div>
  );
};

export default PromotionsList;
